declare global {
    interface Window {
        signalviewConfig?: { apiUrl?: string };
        signalviewDomainInfo?: { orgProxyInfo?: { apiUrl?: string } };
    }
}

const apiHostFromEnvironment = process.env.API_HOST;
const apiHostFromRuntimeConfig =
    localStorage.getItem('API_URL') ||
    window.signalviewDomainInfo?.orgProxyInfo?.apiUrl ||
    window.signalviewConfig?.apiUrl ||
    undefined;

export function getApiHost(): string {
    return apiHostFromEnvironment || apiHostFromRuntimeConfig || window.location.origin;
}
